import React from "react";
import {
  Table,
  TableProps,
} from "@ldp-web/component-library/ui/molecules/table";
import { WrapperComponent } from "../wrapper";
import { Headline } from "@ldp-web/component-library/ui/molecules/headline";
import {
  IComponentCommonProps,
  IHeaderGroupComponentProps,
} from "@ldp/common-types";
import { useRedirectLink } from "../../utils";
import { useSDMRouterContext } from "@ldp/sdm-contexts";

export interface ITableComponentProps
  extends TableProps,
    IComponentCommonProps {
  /** header group props */
  headerGroup?: IHeaderGroupComponentProps;
  /** id of component */
  id?: string;
}

/** Renders a Table with Headline */
export const TableComponent = (props: ITableComponentProps) => {
  const { variantId, rows, alignment, headerGroup, styling, id } = props;

  const router = useSDMRouterContext();
  const redirectToPage = useRedirectLink(router);

  /** props for rendering Headline Component */
  const headerGroupProps = {
    ...headerGroup,
    subTitle: headerGroup?.paragraph?.text,
    title: headerGroup?.headline.text,
    link: headerGroup?.headline?.callToAction,
    clickHandler: redirectToPage,
  };

  return (
    <WrapperComponent styling={styling} id={id}>
      <Headline {...headerGroupProps} />
      <Table alignment={alignment} variantId={variantId} rows={rows} />
    </WrapperComponent>
  );
};

export default TableComponent;
